<template>
  <div class="HistoryRecord">
    <StdLink context="light">
      {{ date }}
    </StdLink><br />
    <span>
      {{ BY }} {{ record.entry_author.email }}
    </span>
  </div>
</template>

<script>
import moment from 'moment'
import { StdLink } from './../StdLink'
import { GENERAL } from './../../locales/es'
moment.locale('es')
export default {
  components: {
    StdLink,
  },
  props: {
    record: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...GENERAL
    }
  },
  computed: {
    date() {
      return this.record ? moment(this.record.created_at).format('LL') : ''
    }
  }
}
</script>

<style scoped>
.HistoryRecord {
  color: #FFF;
  font-size: 0.9em;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/HistoryRecord/HistoryRecord.vue